<template>
  <div>
    <div class="page-title">Edit Schedule Item</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="update"
      btnText="Update Schedule Item"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.schedule-items.page";
export default {
  components: { Form },
  metaInfo() {
    const subject = this.form?.title;
    return {
      title: subject ? `Edit “${subject}” Schedule Item` : `Edit Schedule Item`,
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.ScheduleItem.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
    async update() {
      await this.$api.ScheduleItem.update(this.form);
      this.$router.push("/widgets/schedules");
    },
  },
};
</script>

<style></style>
